module.exports = __webpack_public_path__ + "media/newstyle/images/logo-cda-6c63b1181d0a2a0845e7c4d4ce450c6c.svg";